import styled from 'astroturf/react';
import React from 'react';

const TINY_SCREEN_SIZE = 630;

const PREMIUM_BLUE_COLOR = '#0954d3';

export const ButtonContainer = styled.button`
  border: 0;
  display: flex;
  width: 100%;
  height: 60px;
  margin-top: 8px;
  margin-bottom: 32px;
  padding-right: 40px;
  padding-left: 40px;
  justify-content: center;
  align-items: center;
  align-self: auto;
  border-radius: 4px;
  // box-shadow: 0 2px 8px 0 rgb(0 0 0 / 12%);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  position: relative;
  background-color: ${PREMIUM_BLUE_COLOR};

  &:disabled {
    background-color: #d9d9d9;
  }

  @media (max-width: ${TINY_SCREEN_SIZE}px) {
    padding-right: 12px;
    padding-left: 12px;
  }
`;

export const LongText = styled.span`
  display: flex;

  @media (max-width: ${TINY_SCREEN_SIZE}px) {
    display: none;
  }
`;

export const ShortText = styled.span`
  display: flex;

  @media (min-width: ${TINY_SCREEN_SIZE}px + 1) {
    display: none;
  }
`;

export const RightCaret = styled.span`
  position: relative;
  padding-left: 6px;
  font-weight: 900;
  font-size: 22px;
`;

interface Props {
  longButtonText: string;
  shortButtonText: string;
  onClick: () => void;
  clickable: boolean;
  color?: 'gold' | 'blue';
}

const TranslateButton: React.FC<Props> = ({
  longButtonText,
  shortButtonText,
  onClick,
  clickable,
}: Props): React.ReactElement => {
  return (
    <ButtonContainer onClick={onClick} disabled={!clickable}>
      <LongText>{longButtonText + ' '}</LongText>
      <ShortText>{shortButtonText + ' '}</ShortText>
      <RightCaret>
        <i className="fa fa-caret-right" />
      </RightCaret>
    </ButtonContainer>
  );
};

export default TranslateButton;
